import { FunctionComponent } from 'react';
import { useAuth } from '@sky/xerxes-client-react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import { UserDetails } from '../../component/User';

const ProfilePage: FunctionComponent = () => {
  const { user } = useAuth();

  return (
    <Container>
      <Row>
        <Col>
          <h2>My Profile</h2>
          <UserDetails user={user} />
        </Col>
      </Row>
    </Container>
  );
};

export default ProfilePage;
